import { render, staticRenderFns } from "./BizInvoiceinfoModal.vue?vue&type=template&id=67001da0&"
import script from "./BizInvoiceinfoModal.vue?vue&type=script&lang=js&"
export * from "./BizInvoiceinfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports